if (!customElements.get('empty-cart')) {
  customElements.define(
    'empty-cart',
    class EmptyCart extends HTMLElement {
      constructor() {
        super();
        if (this.dataset.itemsCount <= 0) return;
        this.clearCart();
      }

      async clearCart() {
        const clearUrl = `${window.Shopify?.routes?.root || '/'}cart/clear.js`;

        try {
          const response = await fetch(clearUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          });

          if (response.ok) {
            const cartData = await response.json();
            console.log('Cart is now empty:', cartData);
            
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { cart: cartData }
            }));

            // Redirect or reload if necessary
            // window.location.reload();
            // window.location.href = '/';
          }
        } catch (error) {
          console.error('Manual clear failed:', error);
        }
      }
    }
  );
}